import Vue from 'vue';
import Vuex from 'vuex';
import userModule from './modules/userModule';
import communitiesModule from './modules/communitiesModule';
import modalModule from './modules/modalModule';
import tableModule from './modules/tableModule';
import ticketModule from './modules/ticketModule';
import pollModule from './modules/pollModule';
import eventModule from './modules/eventModule';
import financesModule from './modules/financesModule';
import postModule from './modules/postModule';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    openedCard: false,
    postTitle: '',
    deviceID: '',
    fictiveChat: null
  },
  mutations: {
    loadingFinished(state) {
      state.loading = false;
    },
    loadingStarted(state) {
      state.loading = true;
    },
    cardOpened(state) {
      state.openedCard = true;
    },
    cardClosed(state) {
      state.openedCard = false;
    },
    setPostTitle(state, payload) {
      state.postTitle = payload;
    },
    setDeviceID(state, payload) {
      state.deviceID = payload;
    },
    setFictiveChat(state, payload) {
      payload.communityId = payload.community_id;
      payload.post = {
        id: 'fictive'
      };
      payload.unread_message_counter = '0';
      state.fictiveChat = payload;
    },
    removeFictiveChat(state) {
      state.fictiveChat = null;
    }
  },
  modules: {
    user: userModule,
    communities: communitiesModule,
    modal: modalModule,
    table: tableModule,
    ticket: ticketModule,
    poll: pollModule,
    event: eventModule,
    finances: financesModule,
    post: postModule
  },
  getters: {
    getPostTitle(state) {
      return state.postTitle;
    },
    getFictiveChat(state) {
      return state.fictiveChat;
    }
  }
});
